<!-- Form row -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form (ngSubmit)="f.form.valid && onSubmit(f)" #f="ngForm" novalidate>
          <div class="row">
            <div class="col-md-3 mb-3">
              <label for="inputNumeroExpediente" class="form-label" i18n>Número de caso (*)</label>
              <input type="text" class="form-control" id="inputNumeroExpediente" i18n-placeholder="@@numeroExpedientePlaceholder" placeholder="Número de expediente" name="numero_expediente"
                #numero_expediente="ngModel" [(ngModel)]="model.numero_expediente" required
                [ngClass]="{ 'is-invalid': (numero_expediente.invalid && f.submitted) || (numero_expediente.invalid && (numero_expediente.dirty || numero_expediente.touched))}">
              <div *ngIf="(numero_expediente.invalid && f.submitted) || (numero_expediente.invalid && (numero_expediente.dirty || numero_expediente.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="inputFechaSolicitud" class="form-label" i18n>Fecha de Solicitud (*)</label>
              <input type="date" class="form-control" id="inputFechaSolicitud" name="fecha_solicitud"
                #fecha_solicitud="ngModel" [(ngModel)]="model.fecha_solicitud" required
                [ngClass]="{ 'is-invalid': (fecha_solicitud.invalid && f.submitted) || (fecha_solicitud.invalid && (fecha_solicitud.dirty || fecha_solicitud.touched))}">
              <div *ngIf="(fecha_solicitud.invalid && f.submitted) || (fecha_solicitud.invalid && (fecha_solicitud.dirty || fecha_solicitud.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="selectPlantilla" class="form-label" i18n>Plantilla (*)</label>
              <select class="form-select" id="selectPlantilla" name="id_plantilla" 
                #id_plantilla="ngModel" [(ngModel)]="model.id_plantilla" required
                [ngClass]="{ 'is-invalid': (id_plantilla.invalid && f.submitted) || (id_plantilla.invalid && (id_plantilla.dirty || id_plantilla.touched))}">
                <option *ngFor="let plantilla of plantillas" [value]="plantilla.id">{{plantilla.nombre}}</option>
              </select>
              <div *ngIf="(id_plantilla.invalid && f.submitted) || (id_plantilla.invalid && (id_plantilla.dirty || id_plantilla.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>
          </div> 

          <div class="text-md-end">
            <button type="submit" class="btn btn-primary waves-effect waves-light"><span i18n>Guardar</span></button>
          </div>
        </form>
      </div> <!-- end card-body -->
    </div> <!-- end card-->
  </div> <!-- end col -->
</div>
<!-- end row -->
